import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useParams, useLocation } from 'react-router-dom';
import PageTitle from '../../FormElements/PageTitle';
import BusinessLicenseApplicationContainer from '../../Property/BusinessLicenseApplication/BusinessLicenseApplicationContainer/BusinessLicenseApplicationContainer';

export default function PropertyBusinessLicenseApplicationPage({
	create_business_license_application_endpoint
}) {
	let { id } = useParams();
	const location = useLocation();

	const propertyName = location.state ? location.state.propertyName : '';

	useEffect(
		() => {
			// Log the propertyName to verify it's received correctly
			// console.log('Received propertyName:', propertyName);
		},
		[
			id,
			propertyName
		]
	);

	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link to="/dashboard" className="hover:underline mr-2 md:mr-3">
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
				<Link to={`/properties/${id}`} className="hover:underline mr-2 md:mr-3">
					{propertyName || 'Property Name'}
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<div className="mx-auto grid grid-cols-1 px-12 md:px-0 w-full">
				<PageTitle title="Review License Application" />
				<BusinessLicenseApplicationContainer
					create_business_license_application_endpoint={
						create_business_license_application_endpoint
					}
				/>
			</div>
		</div>
	);
}

PropertyBusinessLicenseApplicationPage.propTypes = {
	create_business_license_application_endpoint: PropTypes.string.isRequired
};
